import React from 'react';
import s from './Selector.scss';
import { Arrow } from '../Arrow/Arrow';
import CheckedIcon from './checked.svg';
import { useView, View } from '../../../../../providers/ViewProvider';
export const Selector = _ref => {
  let {
    options,
    selectedValue,
    onSelect,
    backButtonText,
    onBackButtonClick,
    visible
  } = _ref;
  const {
    setView
  } = useView();
  const handleSelect = value => {
    onSelect(value);
    setView(View.Menu);
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      visibility: visible ? 'visible' : 'hidden'
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: s.backButton,
    onClick: onBackButtonClick
  }, /*#__PURE__*/React.createElement(Arrow, {
    left: true
  }), /*#__PURE__*/React.createElement("h5", {
    className: s.title
  }, backButtonText)), /*#__PURE__*/React.createElement("ul", {
    className: s.list
  }, options.map(_ref2 => {
    let {
      displayText,
      value
    } = _ref2;
    return /*#__PURE__*/React.createElement("li", {
      key: value
    }, /*#__PURE__*/React.createElement("button", {
      className: s.optionButton,
      onClick: () => handleSelect(value)
    }, selectedValue === value ? /*#__PURE__*/React.createElement(CheckedIcon, null) : null, /*#__PURE__*/React.createElement("span", {
      className: s.optionTitle
    }, displayText)));
  })));
};
//# sourceMappingURL=Selector.js.map